// The header timestamp should reflect the session's most recent activity (the
// latest message — e.g. the search you just ran), not when the session was
// first created. Otherwise a fresh search in an older session reads stale
// ("21 mins ago"). Falls back to the session's created time when there are no
// messages yet. ISO-8601 strings compare lexicographically == chronologically.
export const latestMessageTime = (
  messages: ReadonlyArray<{ createdAt?: string }> | undefined,
  fallback?: string
): string | undefined => {
  let newest = '';
  for (const m of messages ?? []) {
    if (m.createdAt && m.createdAt > newest) newest = m.createdAt;
  }
  return newest || fallback;
};
